import { jsx as _jsx } from "react/jsx-runtime";
import { BulletedListPlugin, NumberedListPlugin, useListToolbarButton, useListToolbarButtonState } from '@udecode/plate-list/react';
import { MarkdownBulletListIcon, MarkdownNumberedListIcon } from '../Icons';
import { StyledButton } from './styled';
export function UnorderedListButton() {
    const state = useListToolbarButtonState({
        nodeType: BulletedListPlugin.key
    });
    const { props } = useListToolbarButton(state);
    return /*#__PURE__*/ _jsx(StyledButton, {
        variant: "tertiaryGray",
        size: "m",
        "data-active": props.pressed,
        onClick: props.onClick,
        icon: /*#__PURE__*/ _jsx(MarkdownBulletListIcon, {
            type: "extended"
        }),
        tooltip: "Unordered List",
        "aria-label": "Unordered List",
        "data-test-id": "markdown-editor-unordered-list-button"
    });
}
export function OrderedListButton() {
    const state = useListToolbarButtonState({
        nodeType: NumberedListPlugin.key
    });
    const { props } = useListToolbarButton(state);
    return /*#__PURE__*/ _jsx(StyledButton, {
        variant: "tertiaryGray",
        size: "m",
        "data-active": props.pressed,
        onClick: props.onClick,
        icon: /*#__PURE__*/ _jsx(MarkdownNumberedListIcon, {
            type: "extended"
        }),
        tooltip: "Ordered List",
        "aria-label": "Ordered List",
        "data-test-id": "markdown-editor-ordered-list-button"
    });
}
